import styled from 'styled-components';

export const StyledSummaryRow = styled.div`
  display: flex;
  gap: 0.5rem;

  .label-text {
    font-weight: 400;
  }
`;
